// MicrosoftCallback.jsx
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

const MicrosoftCallback = () => {
  const navigate = useNavigate();
  const { updateUser } = useContext(AuthContext);
  const apiUrl = import.meta.env.VITE_STRAPI_URL || "http://localhost:1337";

  useEffect(() => {
    const processCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      if (code) {
        try {
          const response = await axios.post(`${apiUrl}/api/microsoft-custom`, { code });
          localStorage.setItem("jwt", response.data.jwt);
          localStorage.setItem("user", JSON.stringify(response.data.user));
          updateUser(response.data.user);
          navigate("/mi-cuenta");
        } catch (error) {
          console.error("Error en autenticación con Microsoft:", error);
        }
      } else {
        console.error("No se recibió ningún código de autorización.");
      }
    };

    processCallback();
  }, [apiUrl, navigate, updateUser]);

  return <div>Procesando autenticación con Microsoft...</div>;
};

export default MicrosoftCallback;